import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

function Icon({ name, className, ...props }) {
  return (
    <i
      {...props}
      className={`Icon Icon--${name} ${(className || '')}`}
    />
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
